<template>
  <div v-loading="loading" class="TestKitDetail">
    <div class="TestKitDetail-form">
      <el-form
        label-position="top"
        ref="form"
        label-width="160px"
        :hide-required-asterisk="true"
        :rules="rules"
        :model="form"
        @submit.native.prevent
        size="small"
      >
        <div class="TestKitDetail-form-content">
          <el-form-item
            v-for="(item, index) in questionList"
            :key="index"
            :label="`${index + 1}. ${item.title}：`"
            prop="name"
          >
            <div v-if="item.answerList.length > 0">
              <!-- 对象数组 -->
              <template v-if="isObjectArray(checkJson(item.value))">
                <el-checkbox-group
                  :value="checkJson(item.value).map((item) => item.answerId)"
                >
                  <el-checkbox
                    disabled
                    v-for="(itemA, index) in item.answerList"
                    :key="index"
                    :label="itemA.answerId"
                    >{{ itemA.answerContent }}
                    {{
                      checkJson(item.value)
                        ?.map((subItem) => subItem.answerId)
                        .includes(itemA.answerId)
                        ? checkJson(item.value)?.find(
                            (subItem) => subItem.answerId === itemA.answerId
                          ).remarkContent
                          ? "备注:" +
                            checkJson(item.value)?.find(
                              (subItem) => subItem.answerId === itemA.answerId
                            ).remarkContent
                          : ""
                        : ""
                    }}</el-checkbox
                  >
                </el-checkbox-group>
              </template>
              <!-- 数组 -->
              <template v-else-if="Array.isArray(checkJson(item.value))">
                <el-checkbox-group :value="checkJson(item.value)">
                  <el-checkbox
                    disabled
                    v-for="(itemA, index) in item.answerList"
                    :key="index"
                    :label="itemA.answerId"
                    >{{ itemA.answerContent }}</el-checkbox
                  >
                </el-checkbox-group>
              </template>
              <!-- 对象 -->
              <template v-else-if="typeof checkJson(item.value) === 'object'">
                <el-radio-group :value="checkJson(item.value)?.value">
                  <el-radio
                    disabled
                    v-for="(itemA, index) in item.answerList"
                    :key="index"
                    :label="itemA.answerId"
                    >{{ itemA.answerContent }}
                    {{
                      `${
                        checkJson(item.value)?.value === itemA.answerId
                          ? checkJson(item.value).remark
                            ? "备注:" + checkJson(item.value).remark
                            : ""
                          : ""
                      }`
                    }}</el-radio
                  >
                </el-radio-group>
              </template>
              <template v-else>
                <el-radio-group v-model="item.value" disabled>
                  <el-radio
                    v-for="(itemA, index) in item.answerList"
                    :key="index"
                    :label="itemA.answerId"
                    >{{ itemA.answerContent
                    }}<img
                      v-if="itemA.answerImageUrl"
                      class="image"
                      :src="`${VUE_OSS_PATH}${itemA.answerImageUrl}`"
                  /></el-radio>
                </el-radio-group>
              </template>
            </div>
            <div v-else>{{ checkJson(item.value) }}</div>
          </el-form-item>
        </div>
        <el-form-item>
          <div class="TestKitDetail-form-button">
            <el-button @click="cancel">返回</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { isObjectArray } from "../../utils";
export default {
  name: "zhongShanQuestionnaireDetailBack",
  data() {
    return {
      loading: false,
      questionList: [],
      VUE_OSS_PATH: process.env.VUE_APP_OSS_PATH,
    };
  },
  created() {
    this.findQuestion();
  },
  methods: {
    isObjectArray,
    findQuestion() {
      this.loading = true;
      this.$get(
        `hh/polypInfo/findAllZsly?openId=${this.$route.query.reagentId}`
      )
        .then((res) => {
          const keys = Object.keys(res.data);
          const currentKey = keys[0];
          res.data[currentKey]?.[0]?.questionList?.shift();
          this.questionList = res.data[currentKey]?.[0]?.questionList;
          console.log("this.questionList+++", this.questionList);
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          console.log("err: ", err, "api: hh/polypInfo/findAllZsly");
        });
    },
    checkJson(val) {
      let value = val || "";
      try {
        value = JSON.parse(val);
        if (value > Number.MAX_SAFE_INTEGER) {
          value = val;
        }
      } catch (error) {
        console.log("error: ", error);
      }
      return value;
    },
    cancel() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../style/TestKit/TestKitDetail";
.image {
  margin-left: 10px;
  width: 150px;
}

.disabled {
  ::v-deep .el-upload--picture-card {
    display: none !important;
  }
}
</style>
